export default "__VITE_ASSET__B3M2RAd8__"